import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        icons: {
            icon1: " <img style='height:2rem;' src='images/icon1.png'/> ",
            icon2: " <img style='height:2rem;' src='images/icon2.png'/> ",
            icon3: " <img style='height:2rem;' src='images/icon3.png'/> ",
            icon4: " <img style='height:2rem;' src='images/icon4.png'/> ",
            icon5: " <img style='height:2rem;' src='images/icon5.png'/> ",
            icon6: " <img style='height:2rem;' src='images/icon6.png'/> ",
            icon7: " <img style='height:2rem;' src='images/icon7.png'/> ",
            icon8: " <img style='height:2rem;' src='images/icon8.png'/> ",
            icon9: " <img style='height:2rem;' src='images/icon9.png'/> ",
            icon10: " <img style='height:2rem;' src='images/icon10.png'/> ",
            mark1: " <img style='height:1rem;' src='images/mark1.png'/> ",
            mark2: " <img style='height:1rem;' src='images/mark2.png'/> ",
            mark3: " <img style='height:1rem;' src='images/mark3.png'/> ",
            mark4: " <img style='height:1rem;' src='images/mark4.png'/> ",
            mark5: " <img style='height:1rem;' src='images/mark5.png'/> ",
            mark6: " <img style='height:1rem;' src='images/mark6.png'/> ",
            mark7: " <img style='height:1rem;' src='images/mark7.png'/> ",
            mark8: " <img style='height:1rem;' src='images/mark8.png'/> ",
            mark9: " <img style='height:1rem;' src='images/mark9.png'/> ",
            mark10: " <img style='height:1rem;' src='images/mark10.png'/> ",
        },
        config: {},
        exttype: [],
        bkmenu: null,
        sStopSale: [],

    },
    mutations: {
        // sSetBKMenu(state, pData) {
        //     console.log("in sSetBKMenu")
        //     state.config = pData.config;
        // },
    },
    actions: {},
    modules: {},
    getters: {
        getConfig: (state) => (pId) => {
            console.log(pId);
            var config = state.config;
            try {
                return config[pId].value;
            } catch (error) {
                console.log("getConifg not find key:", pId)
                return null
            }

        }
    }
})